import React from 'react';
import DatePicker from 'react-datepicker';
import { InputWrapper, DateWrapper } from '../css';
import { Box, Text } from '../../design/css';

/**
 * Two-column dashboard filter UI: "opened" date range + "validation" date range (FM / VUL / OCDR / FMSOW).
 */
export function renderDashboardDualDateRangeFilters({
  updateFilters,
  filterByOpenedDates,
  filterByValidationDates,
  startDateLabel,
  endDateLabel,
  startDate,
  endDate,
  completedStartDate,
  completedEndDate
}) {
  return (
    <>
      <div className="col-md-4">
        <Box
          style={{ paddingBottom: 6, paddingLeft: 0 }}
          className="col-md-12"
        >
          <Text fontWeight="700" fontSize="16px">{filterByOpenedDates} </Text>
        </Box>
        <InputWrapper>
          <DateWrapper
            style={{ marginRight: '5px', paddingLeft: 0 }}
            className="col-md-6"
          >
            <DatePicker
              dateFormat="yyyy/MM/dd"
              placeholderText={startDateLabel}
              selected={startDate}
              onChange={value => updateFilters('startDate', value)}
            />
          </DateWrapper>
          <DateWrapper className="col-md-6">
            <DatePicker
              dateFormat="yyyy/MM/dd"
              placeholderText={endDateLabel}
              minDate={startDate}
              selected={endDate}
              onChange={value => updateFilters('endDate', value)}
            />
          </DateWrapper>
        </InputWrapper>
      </div>
      <div className="col-md-4">
        <Box
          style={{ paddingBottom: 6, paddingLeft: 0 }}
          className="col-md-12"
        >
          <Text fontWeight="700" fontSize="16px">{filterByValidationDates} </Text>
        </Box>
        <InputWrapper>
          <DateWrapper
            style={{ marginRight: '5px', paddingLeft: 0 }}
            className="col-md-6"
          >
            <DatePicker
              dateFormat="yyyy/MM/dd"
              placeholderText={startDateLabel}
              selected={completedStartDate}
              onChange={value => updateFilters('completedStartDate', value)}
            />
          </DateWrapper>
          <DateWrapper className="col-md-6">
            <DatePicker
              dateFormat="yyyy/MM/dd"
              placeholderText={endDateLabel}
              minDate={completedStartDate}
              selected={completedEndDate}
              onChange={value => updateFilters('completedEndDate', value)}
            />
          </DateWrapper>
        </InputWrapper>
      </div>
    </>
  );
}
